<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup>
import {
  resolveModelAvatarFields,
  useAiR2Models,
} from "@/composables/useAiR2ModelsAndEffects";
import { resolvePublicR2Url } from "@/utils/r2Url";

function resolveModelListAvatars(data) {
  return Array.isArray(data)
    ? data.map((item) => {
        if (!Array.isArray(item?.models)) return resolveModelAvatarFields(item);
        return {
          ...item,
          models: item.models.map(resolveModelAvatarFields),
        };
      })
    : [];
}

const r2CachedFetch = useR2CachedFetch();

const { data: menuData, pending: menuDataPending } = useAsyncData(
  "menuData",
  async () => {
    const data = await r2CachedFetch("/api/r2/ai/pages/menu.json");
    return data;
  }
);
const { data: productList } = useAsyncData(
  "productList",
  async () => {
    const data = await r2CachedFetch("/api/r2/ai/pages/product-list.json");
    return Array.isArray(data)
      ? data.map((item) => ({
          ...item,
          coverUrl: resolvePublicR2Url(item?.coverUrl),
        }))
      : [];
  },
  { default: () => [] }
);
const { data: modelList } = useAsyncData(
  "modelList",
  async () => {
    const data = await r2CachedFetch("/api/r2/ai/pages/model-list.json");
    return resolveModelListAvatars(data);
  },
  { default: () => [] }
);

provide("menuData", menuData);
provide("productList", productList);
provide("modelList", modelList);

/** 只预热 models，避免 effect 详情页 payload 携带 effects index */
useAiR2Models();
</script>
